import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';

export default function ProductsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

    

      {/* Page Title */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center text-[#333333]">Our Products</h2>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-1 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {/* Hyreach Clipper */}
                      <a href="/hyreach-clipper" className="group cursor-pointer">
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                <div className="w-full h-64 overflow-hidden">
                  <img 
                                      src="/images/ED6451.jpg" 
                    alt="Hyreach Clipper" 
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 text-center">
                  <p className="text-lg font-bold text-[#333333] uppercase">Hyreach Clipper</p>
                </div>
              </div>
            </a>

            {/* Tree Puller */}
            <a href="/tree-puller" className="group cursor-pointer">
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                <div className="w-full h-64 overflow-hidden">
                  <img 
                                      src="/images/527_Hero_02-1024x724.jpg" 
                    alt="Tree Puller" 
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 text-center">
                  <p className="text-lg font-bold text-[#333333] uppercase">Tree Puller</p>
                </div>
              </div>
            </a>

            {/* Add a Grapple */}
            <a href="/add-a-grapple" className="group cursor-pointer">
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                <div className="w-full h-64 overflow-hidden">
                  <img 
                                      src="/images/AAGD_01-1024x683.jpg" 
                    alt="Add a Grapple" 
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 text-center">
                  <p className="text-lg font-bold text-[#333333] uppercase">Add a Grapple</p>
                </div>
              </div>
            </a>

            {/* Grapple Rake */}
            <a href="/grapple-rake" className="group cursor-pointer">
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
                <div className="w-full h-64 overflow-hidden">
                  <img 
                                      src="/images/327_BigMouth_01-1024x576.jpg" 
                    alt="Grapple Rake" 
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 text-center">
                  <p className="text-lg font-bold text-[#333333] uppercase">Grapple Rake</p>
                </div>
              </div>
            </a>
          </div>

          
            

            

            

            
              
            
          
        </div>
      </section>

      {/* Footer */}
      <footer 
        className="bg-cover bg-center relative py-16"
              style={{ backgroundImage: 'url(/images/scaled.jpg)'}}
      >
        <div className="absolute inset-0 bg-[#003d5c]/95"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-white">
            <div>
              <img 
                              src="/images/lagoos.png" 
                alt="AgriWorks Logo" 
                className="h-24 mb-4"
              />
              <h6 className="text-sm mb-4">
                Powered by AgriWorks<br />
               
                <a href="tel:6812968160" className="hover:underline">(681) 296-8160</a>
              </h6>
           
             
            </div>

            <div>
              <h3 className="font-bold mb-4 text-lg">Contact</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="mailto:jolyn.consult@hotmail.com" className="hover:underline">Email: jolyn.consult@hotmail.com</a>
                </li>
                <li>
                  <a href="tel:6812968160" className="hover:underline">Phone: (681) 296-8160</a>
                </li>
                <li>23 Margaret Dr, Somerset, NJ 08873</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-lg">Links</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/products" className="hover:underline">Products</Link>
                </li>
               
                <li>
                  <Link to="/contact" className="hover:underline">Contact Us</Link>
                </li>
                
              </ul>
            </div>

            <div>
              <img 
                              src="/images/made-in-the-usa.webp" 
                alt="Made in USA" 
                className="w-48 mb-4"
              />
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/20 text-center text-sm text-white/80">
                      <p>© {new Date().getFullYear()} AgriWorks Manufacturing LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}
